enum TaskListItemType {
  QUESTIONNAIRE = 'QT',
  PROFILE_UPDATE = 'AP',
  CONSENT_FORM = 'TC',
  INSTITUTIONAL_MATERIAL = 'MI',
  UPLOAD_FILE = 'CA',
  ASK_THE_PHYSICIAN = 'PM',
  GUIDANCE_TO_THE_PATIENT = 'OP',
  SATISFACTION_SURVEY = 'PS'
}

export default TaskListItemType;